import { slice } from '../slices/search';

const nameSpace = slice.name;

export const isLoading = (state: RootState) => state[nameSpace].isLoading;
export const totalCount = (state: RootState) => state[nameSpace].totalCount;
export const playlist = (state: RootState) => state[nameSpace].playlist;
export const queryRequest = (state: RootState) => state[nameSpace].queryRequest;
export const playerPropsPassThrow = (state: RootState) => state[nameSpace].playerPropsPassThrow;
